<template>
  <el-container class="app-layout" v-if="isLoggedIn">

    <el-aside width="260px" class="sidebar-container" :class="{ 'collapsed': isCollapsed }">

      <div class="sidebar-header">
        <router-link class="sidebar-brand" to="/home">
          <h5 class="mb-0 mt-2" v-if="!isCollapsed">会员系统</h5>
        </router-link>
      </div>

      <el-menu
        :default-active="activeMenu"
        class="el-menu-vertical"
        :collapse="isCollapsed"
        router>

        <el-menu-item index="/home">
          <el-icon><i class="fas fa-home"></i></el-icon>
          <template #title>门户主页</template>
        </el-menu-item>

        <template v-if="!isStaff">
          <el-menu-item index="/dashboard">
            <el-icon><i class="fas fa-user-circle"></i></el-icon>
            <template #title>个人中心</template>
          </el-menu-item>
          <el-menu-item index="/apply">
            <el-icon><i class="fas fa-file-signature"></i></el-icon>
            <template #title>积分申请</template>
          </el-menu-item>
          <el-menu-item index="/resources">
            <el-icon><i class="fas fa-archive"></i></el-icon>
            <template #title>资源库</template>
          </el-menu-item>
          <el-menu-item index="/directory">
            <el-icon><i class="fas fa-users"></i></el-icon>
            <template #title>会员通讯录</template>
          </el-menu-item>
          <el-menu-item index="/profile">
            <el-icon><i class="fas fa-pencil-alt"></i></el-icon>
            <template #title>修改资料</template>
          </el-menu-item>
        </template>

        <el-menu-item index="/admin-dashboard" v-if="isStaff" class="admin-link">
          <el-icon><i class="fas fa-shield-halved"></i></el-icon>
          <template #title>管理后台</template>
        </el-menu-item>

      </el-menu>

      <div class="sidebar-footer">
        <el-button @click="handleLogout" type="danger" plain :icon="ElIconDelete" :circle="isCollapsed" class="logout-btn">
          {{ isCollapsed ? '' : '安全退出' }}
        </el-button>
        <el-button @click="isCollapsed = !isCollapsed" :icon="isCollapsed ? ElIconArrowRight : ElIconArrowLeft" circle class="toggle-btn" />
      </div>

    </el-aside>

    <el-main class="main-content-area">
      <router-view/>
    </el-main>
  </el-container>

  <el-container v-else class="public-layout">
    <el-header class="public-header shadow-sm">
      <div class="header-container">
        <router-link class="navbar-brand" to="/" v-if="showPublicHeaderLogo">
          <img src="/logo.png" alt="研究会 Logo" class="public-navbar-logo">
          <span>广东省青年科技创新研究会</span>
        </router-link>
        <div class="navbar-brand-placeholder" v-else></div>
        <el-menu mode="horizontal" :default-active="$route.path" router class="public-nav-menu">
          <el-menu-item index="/">官网首页</el-menu-item>
          <el-menu-item index="/news">新闻与公告</el-menu-item>
          <el-menu-item index="/login" class="login-button-item">
            <el-button type="primary">会员登录</el-button>
          </el-menu-item>
        </el-menu>
      </div>
    </el-header>
    <el-main class="public-main">
      <router-view/>
    </el-main>
  </el-container>

</template>

<script>
// <script> 部分 100% 保持不变
import { ElMessageBox } from 'element-plus'
import { Delete as ElIconDelete, ArrowLeft as ElIconArrowLeft, ArrowRight as ElIconArrowRight } from '@element-plus/icons-vue'

export default {
  name: 'App',
  setup() {
    return {
      ElIconDelete,
      ElIconArrowLeft,
      ElIconArrowRight
    }
  },
  data() {
    return {
      isCollapsed: false,
      staffStatus: localStorage.getItem('isStaff'),
      loggedInStatus: !!localStorage.getItem('authToken'),
    }
  },
  computed: {
    isStaff() {
      return this.staffStatus === 'true';
    },
    isLoggedIn() {
      return this.loggedInStatus;
    },
    activeMenu() {
      return this.$route.path;
    },
    // (公共布局 Logo 逻辑 - 保持不变)
    showPublicHeaderLogo() {
      return this.$route.name !== 'PublicHome';
    }
  },
  methods: {
    async handleLogout() {
      try {
        await ElMessageBox.confirm(
          '您确定要退出登录吗？',
          '安全退出',
          {
            confirmButtonText: '确认退出',
            cancelButtonText: '取消',
            type: 'warning',
            center: true,
          }
        );

        localStorage.removeItem('authToken');
        localStorage.removeItem('isStaff');
        localStorage.removeItem('isFeePaid');
        localStorage.removeItem('isPremiumMember');
        this.staffStatus = null;
        this.loggedInStatus = false;
        this.$router.push('/login');

      } catch (action) {
        console.log('登出操作已取消');
      }
    },
  },
  watch: {
    '$route'() {
      this.loggedInStatus = !!localStorage.getItem('authToken');
      this.staffStatus = localStorage.getItem('isStaff');
    }
  }
}
</script>


<style>
/* (全局样式 - 保持不变) */

:root {
  /* Element Plus 默认是 14px，改成 16px 或 18px 会让按钮、菜单、表格都变大 */
  --el-font-size-base: 18px;

  /* 如果觉得小号字体（如辅助文字）也太小，可以一起改 */
  --el-font-size-small: 16px;
}
body {
  font-family: 'Noto Sans SC', sans-serif;
  background-color: var(--el-bg-color-page);
  font-size: 18px !important;
  line-height: 1.6;
}
#app {
  font-family: 'Noto Sans SC', sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: var(--el-text-color-primary);
}
</style>


<style scoped>
/* (A) 公共布局 (已退出) - 保持不变 */
.public-layout {
  display: flex;
  flex-direction: column;
  min-height: 100vh;
}
.public-header {
  background-color: #fff;
  border-bottom: 1px solid var(--el-border-color-light);
  padding: 0;
  height: 90px; /* (使用我们之前定下的 90px 高度) */
  line-height: 89px;
  transition: height 0.3s ease;
}
.header-container {
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 100%;
  padding: 0 40px;
}
.navbar-brand {
  display: flex;
  align-items: center;
  text-decoration: none;
  color: var(--el-text-color-primary);
}
.public-navbar-logo {
  height: 70px; /* (使用我们之前定下的 70px Logo) */
  width: auto;
  margin-right: 12px;
  vertical-align: middle;
}
.navbar-brand-placeholder {
  width: 1px;
}
.navbar-brand span {
  font-weight: 600;
  font-size: 1.1rem;
}
.public-nav-menu {
  border-bottom: none;
  height: 89px;
}
.public-nav-menu .login-button-item {
  margin-left: 1rem;
}
.public-main {
  padding: 0;
  background-color: var(--el-bg-color-page);
  flex-grow: 1;
}


/* --- (B) 会员侧边栏布局 (已登录) --- */
.app-layout {
  height: 100vh;
}
.sidebar-container {
  background: #fff;
  box-shadow: 0 0 15px rgba(0,0,0,0.1);
  transition: width 0.3s ease;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}
.sidebar-container.collapsed {
  width: 64px !important;
}

/* 头部 (Logo) */
.sidebar-header {
  display: flex;
  align-items: center;
  padding: 1rem;
  border-bottom: 1px solid var(--el-border-color-light);
  min-height: 65px;
}
.sidebar-brand {
  display: flex;
  flex-direction: column;
  align-items: flex-start; /* 左对齐 */
  text-decoration: none;
  color: #333;
  font-weight: 600;
  white-space: nowrap;
  transition: opacity 0.3s ease;
  width: 100%;
}

/* 【!! 最终修复：完美对齐 !!】 */
.sidebar-brand h5 {
  font-size: 1.2rem;
  font-weight: 600;
  padding-left: 33px; /* (49px 目标 - 16px 父内边距) */
}
.sidebar-container.collapsed .sidebar-brand {
  opacity: 0;
  display: none;
}

/* (导航菜单) */
.el-menu-vertical {
  border-right: none;
  flex-grow: 1;
  overflow-y: auto;
}
.el-menu-vertical:not(.el-menu--collapse) {
  width: 260px;
}
.el-menu-item [class^="fas"] {
  width: 24px;
  text-align: center;
  font-size: 1.1rem;
  color: var(--el-text-color-regular);
}
.el-menu-item.is-active [class^="fas"] {
  color: var(--el-color-primary);
}
.el-menu-item.admin-link { /* (管理员链接高亮) */
  color: var(--el-color-danger);
}
.el-menu-item.admin-link.is-active {
  color: var(--el-color-danger);
}
.el-menu-item.admin-link.is-active [class^="fas"] {
  color: var(--el-color-danger);
}
.el-menu-item.admin-link:hover {
  background-color: var(--el-color-danger-light-9);
}

/* (底部) */
.sidebar-footer {
  padding: 1rem;
  border-top: 1px solid var(--el-border-color-light);
  display: flex;
  justify-content: space-between;
  align-items: center;
  transition: padding 0.3s ease;
}
.sidebar-container.collapsed .sidebar-footer {
  flex-direction: column;
  justify-content: center;
  padding: 1rem 0.5rem;
  gap: 1rem;
}
.sidebar-container.collapsed .logout-btn {
  margin: 0;
}
.toggle-btn {
  margin-left: auto;
}
.sidebar-container.collapsed .toggle-btn {
  margin-left: 0;
}

/* (主内容区) */
.main-content-area {
  background-color: var(--el-bg-color-page);
  padding: 1.5rem;
  overflow-y: auto;
}
</style>